<layout-navbar [mode]="navbarMode" />
<router-outlet />
<layout-footer />
